import Vue from "vue";


interface SubnetTypeMap {
    [key:string]:string
}


export const getSubnetTypes = ():SubnetTypeMap => {
    return ({
        Normal: Vue.$trans(`云服务器子网`),
        Reserve: Vue.$trans(`终端子网`),
        Physical: Vue.$trans(`裸金属服务器子网`)
    } as any);
}

